import { mixed, number, object, setLocale, string } from 'yup'
import { es } from 'yup-locales'

import {
  IMPRESION_FORMATO,
  ImpresionDocumentoProps,
  ImpresionFormatoProps,
  ImpresoraAsignacionProps,
} from '../interfaces/impresora.ts'
import { ApiImpresoraAsignacionInputProps } from '../interfaces/impresora.ts'
import { getFormatosDocumento, IMPRESION_COPIAS_MAX } from '../services/impresionDocumento.ts'

setLocale(es)

/** Valores del formulario de asignación de impresora a un documento */
export interface ImpresoraAsignacionFormProps {
  documento: ImpresionDocumentoProps
  impresoraId: string
  formato: ImpresionFormatoProps
  copias: number
  nombreImpresora: string
}

export const impresoraAsignacionToForm = (
  documento: ImpresionDocumentoProps,
  asignacion?: ImpresoraAsignacionProps | null,
): ImpresoraAsignacionFormProps => ({
  documento,
  impresoraId: asignacion?.impresoraId ?? asignacion?.impresora?._id ?? '',
  formato:
    asignacion?.formato && getFormatosDocumento(documento).includes(asignacion.formato)
      ? asignacion.formato
      : IMPRESION_FORMATO.ROLLO,
  copias: asignacion?.copias ?? 1,
  nombreImpresora: asignacion?.nombreImpresora ?? '',
})

export const impresoraAsignacionFormToInput = (
  form: ImpresoraAsignacionFormProps,
): ApiImpresoraAsignacionInputProps => ({
  documento: form.documento,
  impresoraId: form.impresoraId,
  formato: form.formato,
  copias: Number(form.copias),
  nombreImpresora: form.nombreImpresora?.trim() ?? '',
})

export const impresoraAsignacionValidator = object({
  documento: mixed<ImpresionDocumentoProps>().required(),
  impresoraId: string().required('Seleccione la impresora'),
  formato: mixed<ImpresionFormatoProps>()
    .required('Seleccione el formato')
    .test('formato-documento', 'Formato no disponible para este documento', (value, ctx) =>
      value ? getFormatosDocumento(ctx.parent.documento).includes(value) : false,
    ),
  copias: number()
    .typeError('Indique un número')
    .integer('Debe ser un número entero')
    .min(1)
    .max(IMPRESION_COPIAS_MAX)
    .required(),
  nombreImpresora: string().trim().max(150).default(''),
})
